import { formatDate } from '@luxuryescapes/lib-refunds'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Typography from 'LuxKit/Typography/Typography'
import InlineIcon from 'components/utils/InlineIcon'
import type { ReactElement } from 'react'
import React from 'react'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

interface Props {
  icon?: ReactElement | false
  cancellationPolicy: App.BedbankCancellationPolicy
  showHotelOnly?: boolean
}

function BedbankPropertyCancellationPoliciesBase({ icon, cancellationPolicy, showHotelOnly = true }: Props) {
  const intl = useIntl()
  const hasRateCancellationPolicy = !!cancellationPolicy.policies.length

  const formattedDate = hasRateCancellationPolicy
    ? formatDate.formattedShortDateByTimezone(cancellationPolicy.policies[0]?.start, cancellationPolicy.policies[0]?.timezone)
    : undefined

  const cancellationLabel = (() => {
    if (hasRateCancellationPolicy && formattedDate && showHotelOnly) {
      return intl.formatMessage({
        id: 'Qhyc_JWlQeeTSXs8VWFx',
        defaultMessage: 'Free cancellation until {date} (hotel only)',
        description: 'Free cancellation with deadline date and hotel only qualifier',
      }, { date: formattedDate })
    }
    if (hasRateCancellationPolicy && formattedDate) {
      return intl.formatMessage({
        id: 'gktmLCleK12tewgamHG2',
        defaultMessage: 'Free cancellation until {date}',
        description: 'Free cancellation with deadline date for bedbank property cancellation policy',
      }, { date: formattedDate })
    }
    if (showHotelOnly) {
      return intl.formatMessage({
        id: 'T33MW5Kx2TaE6WEvuXg5',
        defaultMessage: 'Free cancellation (hotel only)',
        description: 'Free cancellation with hotel only qualifier in the cancellation flow',
      })
    }
    return intl.formatMessage({
      id: 'aECa3E9nHyhywEfWm44g',
      defaultMessage: 'Free cancellation',
      description: 'Free cancellation text for bedbank property cancellation policy',
    })
  })()

  return <BodyTextBlock startIcon={icon} variant="medium">
    <Typography colour="highlight-secondary" as="b" wrap="no-wrap">
      {cancellationLabel}
    </Typography>
    <Typography as="span" wrap="no-wrap">
      <InlineIcon Icon={LineInfoCircleIcon} />
    </Typography>
  </BodyTextBlock>
}

export default BedbankPropertyCancellationPoliciesBase
